@use "@fukuri-admins/ui/layout" as *;

.formTitle {
  @include typography("Jp/20_W6");
  color: text("High");
}
